export default {
    ECO_MODE: 'ECO_MODE',
    PERFORMANCE_MODE: 'PERFORMANCE_MODE',
};
